import React from 'react'
import PropTypes from 'prop-types'

import Footer from 'components/corpSite/components/careguide-corp/footer'
import Nav from 'components/corpSite/components/careguide-corp/nav'
import makeCareguideCorp from 'components/corpSite/components/careguide-corp/styled'

const RawCareguideCorp = makeCareguideCorp('div')

const getSelected = (page) => {
  switch (page) {
    case 'child-care':
    case 'home-care':
    case 'pet-care':
    case 'elder-care':
    case 'caregiver-services':
      return 'caregiver'
    case 'payroll-services':
      return 'payroll'
    case 'news-ideas':
    case 'branding':
    case 'about':
    case 'team':
    case 'careers':
      return 'company'
    case 'contact':
      return 'contact'
    case 'home':
      return 'home'
  }
}

const StaticLayout = ({ children, page }) => {
  const selected = getSelected(page)

  return (
    <RawCareguideCorp>
      <Nav selected={selected} fixed />
      {children}
      <Footer />
    </RawCareguideCorp>
  )
}

StaticLayout.propTypes = {
  children: PropTypes.node.isRequired,
  page: PropTypes.string.isRequired,
}

export default StaticLayout
